import { html, css, LitElement } from 'lit-element';
import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';
import { clone, cloneDeep } from 'lodash-es';
import { library, dom } from "@fortawesome/fontawesome-svg-core";   
 
import { INTRIVITY_LOAD_RESOURCES, emitEvent, hasLocalStorage } from './utility.js';
import { db } from './intrivity_app.js';

import './domain_editor.js';
import { t, Localized, LOCALES } from './i18n.js';
import { DOMAIN_NAMES } from './domains.js';

// Manage Domains
export class IntrivityAdminDomains extends Localized(LitElement) {

    static get styles() {
        return css`

        `;
    }
    
    static get properties() {
        return {
            user_profile: { type: Object },
            selected: { type: String },
            locale: { type: String }         // language being edited
        };
    }

    constructor() {
        super();
        this.locale = 'en';
    }

    connectedCallback() {
        super.connectedCallback();
    }
    
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    
    // This method is no longer used as the DOMAIN_EDITOR_RELEASE event is handled within domain_editor.js
    released_unused(e) {
        this.selected = undefined;
        this.requestUpdate();
        //localStorage.getItem("username") === null
    }
    
    render() {
        // Every known language, enabled or not: a translation is written here
        // before it is switched on.
        const checkoutKey = (name) => 'domains/' + name + (this.locale === 'en' ? '' : '.' + this.locale) + '_editor';
        return html`
            ${this.selected ? html`
                <intrivity-domain-editor .user_profile=${this.user_profile} .domain_name=${this.selected} .locale=${this.locale}></intrivity-domain-editor>
            `: html`
                <div style="margin: 10px;">
                    <h3>${t('adminDomains.title')}</h3>
                    <label>
                        ${t('adminDomains.language')}
                        <select @change=${(e) => { this.locale = e.target.value; }}>
                            ${Object.keys(LOCALES).map((code) => html`
                                <option value=${code} ?selected=${code === this.locale}>${LOCALES[code].name}</option>
                            `)}
                        </select>
                    </label>
                    <div style="margin-top: 5px;">
                        ${Object.values(DOMAIN_NAMES).map((name) => html`
                            <mwc-button outlined @click=${() => { this.selected = name; }}>
                                ${t(hasLocalStorage(checkoutKey(name)) ? 'adminDomains.resume' : 'adminDomains.checkOut', { domain: t(`domain.${name}.name`) })}
                            </mwc-button>
                        `)}
                    </div>
                    <mwc-button style="margin-top: 5px;" outlined @click=${(e)=> { emitEvent(INTRIVITY_LOAD_RESOURCES, {}, this); } }>
                        ${t('adminDomains.reload')}
                    </mwc-button>
                </div>
            `}
        `
    } 
}
if (!customElements.get('intrivity-admin-domains')) customElements.define('intrivity-admin-domains', IntrivityAdminDomains);
